import { NotificationPresenterModel } from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace NotificationActions {
  export class FetchNotification {
    static readonly type = '[Notification] Fetch NotificationActions';
    constructor(
      public payload: {
        skip: number;
        limit?: number;
        replace: boolean;
      },
    ) {}
  }

  export class FetchNotificationCount {
    static readonly type = '[Notification] Fetch NotificationActions Count';
    constructor(
      public payload?: {
        ignoreNewNotifications: boolean;
      },
    ) {}
  }

  export class MarkNotificationAsRead {
    static readonly type = '[Notification] Mark Notification As Read';
    constructor(
      public payload: {
        id: string;
      },
    ) {}
  }

  export class ScheduleNotificationFetching {
    static readonly type = '[Notification] Schedule Notification Fetching';
  }

  export class FetchTransitoryNotificationView {
    static readonly type = '[Notification] Fetch Transitory Notification View';
    constructor(
      public payload: {
        id: string;
        notification?: NotificationPresenterModel;
      },
    ) {}
  }
}
